(function () {
  function init() {

    /* FAQ accordéon */
    var faqItems = document.querySelectorAll('.pg-faq-item');
    faqItems.forEach(function (item) {
      var btn = item.querySelector('.pg-faq-q');
      if (!btn) return;
      btn.addEventListener('click', function (e) {
        e.preventDefault();
        var isOpen = item.classList.contains('pg-open');
        faqItems.forEach(function (i) { i.classList.remove('pg-open'); });
        if (!isOpen) item.classList.add('pg-open');
      });
    });

    /* Sommaire toggle */
    var toc    = document.querySelector('.pg-toc');
    var tocBtn = toc && toc.querySelector('.pg-toc-toggle');
    if (tocBtn) {
      tocBtn.addEventListener('click', function () {
        var closed = toc.classList.toggle('pg-toc-closed');
        tocBtn.setAttribute('aria-expanded', closed ? 'false' : 'true');
      });
    }

    /* Scroll doux ancres sommaire */
    document.querySelectorAll('.pg-toc-list a').forEach(function (link) {
      link.addEventListener('click', function (e) {
        var target = document.querySelector(this.getAttribute('href'));
        if (!target) return;
        e.preventDefault();
        target.scrollIntoView({ behavior: 'smooth', block: 'start' });
      });
    });

  }

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', init);
  } else {
    init();
  }
})();